module.exports = __webpack_public_path__ + "img/Flunder_1.cd29c87c.jpeg";